import { createTheme } from '@mui/material/styles';

// Create a theme instance with RTL direction
const theme = createTheme({
  direction: 'rtl', // Set RTL direction
  // Add other theme configurations here if needed
});

export default theme;
